export default __webpack_public_path__ + "static/media/slide2_w_bg.6f5f175f.png";